<template>
  <box style="max-width: 50rem;">
    <template v-slot:controls v-if="controls">
      <grab-control @grabstart="(e) => $emit('grabstart', e)" @grabend="(e) => $emit('grabend', e)"></grab-control>
      <kebab-menu>
        <action-link icon-left="icon-settings" size="small" class="mb-1" @click="$emit('configure')" v-if="editable">{{ $t('widgets.Dashboard.configure') }}</action-link>
        <action-link icon-left="icon-trash" size="small" @click="$emit('delete')">{{ $t('widgets.Dashboard.remove') }}</action-link>
      </kebab-menu>
    </template>

    <template v-slot:title>
      <div class="latest-orders__title text-color-space text--bold">{{ $t('widgets.Dashboard.LatestOrders.latestOrders') }}</div>
    </template>

    <div class="latest-orders">
      <orders-list date-field="orderedAt" :orders="orders ? orders.content : []" :loading-items="5" :loading="$apollo.queries.orders.loading"></orders-list>
      <div>
        <v-button width="full" class="mt-2 text-color-primary latest-orders__btn" @click="goToOrders()">{{ $t('widgets.Dashboard.LatestOrders.showAllOrders') }}</v-button>
      </div>
    </div>
  </box>
</template>

<script>
import OrdersList from '@/components/OrdersList'
import Box from '@/ui/slots/Box'

import KebabMenu from '@/ui/controls/KebabMenu'
import ActionLink from '@/ui/controls/ActionLink'
import GrabControl from '@/ui/controls/GrabControl'
import vButton from '@/ui/controls/vButton'

import { LatestOrdersGQL } from './queries'

import hasActiveContracts from '@/mixins/hasActiveContracts'

const now = new Date()
/**
 * @returns { Date }
 */
const threeMonthAgo = () => {
  const date = new Date()

  if (date.getMonth() === 0) {
    return new Date(date.getFullYear() - 1, 10, 1)
  } else {
    return new Date(date.getFullYear(), date.getMonth() - 2, 1)
  }
}

const queryVars = {
  descending: true,
  orderedAtFrom: threeMonthAgo().toISOString(),
  orderedAtTo: now.toISOString(),
  sortBy: 'ORDERED_AT'
}

const activeFilter = {
  value: null,
  name: 'Все'
}

export default {
  props: {
    size: {
      type: Number,
      default: 5
    },

    controls: {
      type: Boolean,
      default: false
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  mixins: [hasActiveContracts],

  components: {
    Box,
    OrdersList,
    vButton,
    KebabMenu,
    ActionLink,
    GrabControl
  },

  apollo: {
    orders: {
      query: LatestOrdersGQL,
      variables () {
        return {
          params: {
            ...queryVars,
            page: 0,
            size: this.size,
            status: activeFilter.value
          }
        }
      },
      update: data => data.merchant.orders,
      skip () { return !this.hasActiveContracts }
    }
  },

  methods: {
    goToOrders () {
      this.$router.push({
        name: 'orders'
      })
    }
  }
}
</script>

<style lang="scss">
  .latest-orders {
    &__btn {
      padding-top: 1.2rem;
      padding-bottom: 1.2rem;
    }
  }
</style>
